<template>
    <div>
      <page-fade v-if="pageControl.showFront" :pagecontrol="pageControl" :tag="tag" :pageType="pageType" :search-query="searchKeyword" :key="refresh"></page-fade>
      <blogpostpanel
        v-for="blog in bloglistSlice"
        v-bind:key="blog.pk"
        :blogpost="blog"/>
      <page-fade :pagecontrol="pageControl" :tag="tag" :pageType="pageType" :search-query="searchKeyword"></page-fade>
    </div>
</template>

<script>
  import blogpostpanel from './BlogPost'
  import pageFade from './PageFade'

  export default {
  name: 'all-blog-posts',
  components: {
    blogpostpanel,
    pageFade
  },
  props: {
    func: {
      type: String,
      required: true
    },
    searchQuery: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      pageControl: {
        page: 0,
        maxPage: 1,
        showFront: false,
        sl: '',
        newerPage: null,
        prev_page: null
      },
      blogpostsnum: 0,
      blogList: [],
      tag: null,
      pageType:null,
      refresh: 1,
      searchKeyword: ''
    }
  },
  created () {
    this.updateContent()
  },
  mounted () {
  },
  methods: {
    showdata () {
      console.log(this.pagecontrol)
    },
    updateContent () {
      this.pageType = this.func;
      var page = 1;
      // console.log(Number(this.$route.params.topage))
      if (this.func === 'search') {
        if (this.$route.query.page) {
          page = Number(this.$route.query.page) || 1
        }
      } else if (this.$route.params.topage) {
        page = Number(this.$route.params.topage)
        // console.log(page)
      }
      if (this.func === 'index' || this.func === 'profile') {
        // console.log('index')
        this.allBlogPosts(page)
      } else if (this.func === 'tag') {
        if (this.$route.params.tag) {
          let tag = this.$route.params.tag
          this.tag = tag
          console.log('load tag page')
          const tagKeyword = this.searchQuery || this.$route.query.q || ''
          this.tagBlogPosts(tag, page, tagKeyword)
          // this.$emit('update:foo', tag) // mean what
        }
      } else if (this.func === 'search') {
        const keyword = this.searchQuery || this.$route.query.q || ''
        this.searchKeyword = keyword
        this.searchBlogPosts(keyword, page)
      }
    },
    initControl (res) {
      this.blogList = res.blogposts;
      if (typeof res.blogpostsnum === 'number') {
        this.blogpostsnum = res.blogpostsnum;
        this.$store.commit('assignment', res.blogpostsnum)
      }

      this.pageControl.maxPage = res.max_page;
      this.pageControl.page = res.page;
      this.pageControl.sl = res.sl || '0:0';
      this.pageControl.newerPage = res.newer_page;
      this.pageControl.prev_page = res.prev_page;
      this.pageControl.showFront = this.pageControl.page > 1;
    },
    async allBlogPosts (page) {
      const start = Date.now();
      const reqUrl = this.$store.state.baseUrl + '/blog/api/allblogs/' + page;
      await this.$http.get(reqUrl)
        .then((response) => {
          const millis = Date.now() - start;
          console.log(`seconds elapsed = ${Math.floor(millis / 1000)}`);
          var res = JSON.parse(response.bodyText);
          this.$store.commit('assignAllBlogs', res);
          this.initControl(res)
        })
    },
    resetControl(){
      this.blogList = [];
      this.blogpostsnum = 0;
      this.$store.commit('assignment', 0);
      this.pageControl.maxPage = 1;
      this.pageControl.page = 1;
      this.pageControl.sl = '0:0';
      this.pageControl.newerPage = null;
      this.pageControl.prev_page = null;
      this.pageControl.showFront = false;
    },
    async searchBlogPosts(keyword, page){
      if(!keyword || keyword.trim() === ''){
        this.resetControl();
        this.searchKeyword = '';
        return;
      }
      const reqUrl = this.$store.state.baseUrl + '/blog/api/search/' + page + '?q=' + encodeURIComponent(keyword);
      await this.$http.get(reqUrl)
        .then((response) => {
          var res = JSON.parse(response.bodyText);
          this.searchKeyword = keyword;
          this.initControl(res)
        })
    },
    async tagBlogPosts (tag, page, keyword = '') {
      let tagContentCache = this.$store.state.tagContent || {};
      const trimmedKeyword = (keyword || '').trim();
      if(tag in tagContentCache){
        if (trimmedKeyword) {
          this.applyTagSearchResults(tagContentCache[tag].blogposts, trimmedKeyword, page);
        } else {
          var tagBlogsSplitByPage = this.splitByPage(tagContentCache[tag],page)
          this.searchKeyword = '';
          this.initControl(tagBlogsSplitByPage);
          console.log("find tag blogs cache");
        }
      }else{
        console.log('tag in tagBlogPosts:' + tag);
        let reqUrl = this.$store.state.baseUrl + '/blog/api/tag/' + tag + ',' + page
        console.log(reqUrl);
        await this.$http.get(reqUrl)
          .then((response) => {
            var res = JSON.parse(response.bodyText);
            tagContentCache[tag] = res;
            this.$store.commit('assignTagContent', tagContentCache);
            if (trimmedKeyword) {
              this.applyTagSearchResults(res.blogposts, trimmedKeyword, page);
            } else {
              this.searchKeyword = '';
              this.initControl(res)
            }
          })
      }
    },
    applyTagSearchResults(posts, keyword, page) {
      const filtered = this.filterPostsByKeyword(posts, keyword);
      this.searchKeyword = keyword;
      this.setManualControl(filtered, page);
    },
    setManualControl(posts, page) {
      const pageSize = 3;
      const total = posts.length;
      const maxPage = Math.max(1, Math.ceil(total / pageSize));
      const currentPage = Math.min(Math.max(page, 1), maxPage);
      this.blogList = posts;
      this.blogpostsnum = total;
      this.$store.commit('assignment', total);
      this.pageControl.maxPage = maxPage;
      this.pageControl.page = currentPage;
      this.pageControl.sl = String(pageSize * (currentPage - 1)) + ':' + String(pageSize * currentPage);
      this.pageControl.newerPage = currentPage > 1 ? currentPage - 1 : null;
      this.pageControl.prev_page = currentPage < maxPage ? currentPage + 1 : null;
      this.pageControl.showFront = currentPage > 1;
    },
    filterPostsByKeyword(posts, keyword) {
      const lowerKeyword = keyword.toLowerCase();
      if (!Array.isArray(posts) || !lowerKeyword) {
        return posts || [];
      }
      return posts.filter((post) => {
        const fields = post.fields || {};
        const title = (fields.title || '').toLowerCase();
        const description = (fields.description || '').toLowerCase();
        const body = (fields.body || '').toLowerCase();
        const tagNames = Array.isArray(post.tags)
          ? post.tags.map((tag) => (tag.fields && tag.fields.name ? tag.fields.name.toLowerCase() : '')).join(' ')
          : '';
        return (
          title.includes(lowerKeyword) ||
          description.includes(lowerKeyword) ||
          body.includes(lowerKeyword) ||
          tagNames.includes(lowerKeyword)
        );
      });
    },
    splitByPage(res, page){
      res.page=page;
      res.sl=String(3 * (page - 1)) + ':' + String(3 * (page - 1) + 3);
      res.newer_page=page > 1 ? page - 1 : NaN;
      res.prev_page= page<res.max_page ? page+1 :NaN;
      console.log(res);
      return res
    }
  },
  watch: {
    '$route' (to, from) {
      this.updateContent();
      this.refresh = !this.refresh;
      console.log(this.refresh)
    }
  },
  computed: {
    bloglistSlice: function () {
      var slices = this.pageControl.sl.split(':');
      var start = parseInt(slices[0]);
      var end = parseInt(slices[1]);
      return this.blogList.filter(function(item, index) {
        return index >= start && index < end;
      })
    },
  }
}
</script>

<style scoped>
</style>
